import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalization } from 'Hooks';
import { DialogWithActions } from 'Components';
import { storeCardTransactions, closeKycDialog } from 'Stores/CardTransactions/slices';
import { storeCmsData } from 'Stores/App';

type DialogKycProps = {};

const DialogKyc: FunctionComponent<DialogKycProps> = () => {
  const dispatch = useDispatch();
  const { isOpenKycDialog, kycDialogContent } = useSelector(storeCardTransactions);
  const cmsData = useSelector(storeCmsData);
  const localization = useLocalization();

  const hide = () => {
    dispatch(closeKycDialog());
  };

  const handleGoToApp = () => {
    // Kullanıcı aygıt tipini kontrol ederek uygun link'i açacak
    const userAgent = navigator.userAgent || navigator.vendor;

    // Huawei cihazları için AppGallery link'i
    if (/Huawei/i.test(userAgent) || /Honor/i.test(userAgent)) {
      window.open('https://appgallery.huawei.com/app/C102347171', '_blank');
    } else {
      // Diğer cihazlar için GO link (Android ve iOS)
      window.open('https://istanbulkart.go.link?adj_t=1r9k32kh', '_blank');
    }

    hide();
  };

  // CMS'den metin içeriğini al, yoksa fallback kullan
  const getKycContent = () => {
    // CMS key'i 1058 ise direkt CMS'den al
    if (kycDialogContent === '1058' && cmsData?.CmsKeys?.['1058']) {
      return cmsData.CmsKeys['1058'];
    }

    // CMS'de tanımlı özel mesaj varsa onu kullan
    if (cmsData?.CmsKeys?.['1058']) {
      return cmsData.CmsKeys['1058'];
    }

    // Fallback: ResponseDescription'dan gelen mesaj veya varsayılan
    return kycDialogContent || '';
  };

  const getGoToAppButtonText = () => {
    return cmsData?.CmsKeys?.['web_kyc_btn_go_to_app'] || localization?.web_kyc_btn_go_to_app || 'Uygulamaya git';
  };

  const getGiveUpButtonText = () => {
    return cmsData?.CmsKeys?.['web_kyc_btn_give_up'] || localization?.web_kyc_btn_give_up || 'Vazgeç';
  };

  return (
    <DialogWithActions
      open={isOpenKycDialog}
      hide={hide}
      text={getKycContent()}
      title={localization?.cant_apply_popup_title}
      secondaryButton={{
        label: getGiveUpButtonText(),
        handleClick: hide,
        type: 'outlined',
      }}
      primaryButton={{
        label: getGoToAppButtonText(),
        handleClick: handleGoToApp,
      }}
      disableClickOutside={true}
    />
  );
};

export default DialogKyc;
